document.addEventListener('DOMContentLoaded', function() {


    FS('.schedule .filter-schedule-type', 'all').onClick(function (){
      // FS(this).addUniqueClass('filter-select-item--selected');

        FS('.schedule .filter-select-item--selected').removeClass('filter-select-item--selected');
        FS(this).addClass('filter-select-item--selected');


        scheduleFilter();
    });

    FS('.schedule .filter-radio-item', 'all').onClick(function (){
        FS(this).addUniqueClass('filter-radio-item--checked');
        scheduleFilter();
    });

    FS('.schedule__item', 'all').onClick(function (){
       FS(this).addUniqueClass('schedule__item--selected');
    });



    FS('.schedule__join', 'all').onClick(function (){
        let selected_title = '';
        let selected_time = '';
        let selected_info = '';
        if(document.querySelector('.schedule .schedule__item--selected')){
             selected_title = FS('.schedule .schedule__item--selected .schedule__item-name').getText();
             selected_time = FS('.schedule .schedule__item--selected .schedule__item-time').getText();
             selected_info = FS('.schedule .schedule__item--selected .schedule__item-type').getHtml();
        }else{
             selected_title = FS('.schedule .schedule__item .schedule__item-name').getText();
             selected_time = FS('.schedule .schedule__item .schedule__item-time').getText();
             selected_info = FS('.schedule .schedule__item .schedule__item-type').getHtml();
        }


        FS('.schedule__popup .schedule__popup-text-primary').setText(selected_title);
        FS('.schedule__popup .schedule__popup-text-secondary').setHtml(selected_info);
        FS('.schedule__popup .schedule__popup-time').setText(selected_time);

        popup('.schedule__popup').show();


    });


});


function scheduleFilter(){

    let selected_type = FS('.schedule .filter-select-item--selected').getData('type');
    let selected_mode = FS('.schedule .filter-radio-item--checked').getData('mode');

    let schedule_items = FS('.schedule__item', 'all').elements();

    let i = 0;

    schedule_items.forEach(element => {
        if(element.classList.contains('schedule__' + selected_type) && element.classList.contains('schedule__' + selected_mode)){
            if(i === 0){
                FS(element).addUniqueClass('schedule__item--selected');
            }
            i++;
            element.querySelector('.schedule__item-num').innerText = i + ' /';
            element.classList.add('schedule--show');
        }else{
            element.classList.remove('schedule--show');
        }

    });







}
class __fs_popup{

    selector;

    constructor(selector) {
        this.selector = FS(selector);
    }

    show(){
        this.hideAll();
        this.selector.addUniqueClass('popup--active');
        FS('body').addClass('popup-showing');
    }

    hideAll(){
        FS('.popup--active', 'all').removeClass('popup--active');
        FS('body').removeClass('popup-showing');
    }


}


function popup(selector = null){
    return new __fs_popup(selector);
}
document.addEventListener('DOMContentLoaded', function() {
    FS('.popup-close-btn', 'all').onClick(function (){
       popup().hideAll();
    });
});